<template>
	<div class="modifiedData">
		<div class="modifiedDataContainer">
			<div class="modifiedDataTitle">

				<span @click="changeInfo">柜柜圈&nbsp;></span>
				<span>个人资料</span>
			</div>
			<div class="modifiedDataBody">
				<div class="modifiedDataImg">
					<!--<img :src="userInfo.logo_url==''?'../assets/logo.png':userInfo.logo_url" alt="" />-->
					<img :src="userInfo.logo_url" alt="" />
				</div>
				<div class="modifiedDatafix">
					<div class="modifiedDataItem">
						昵称：{{userInfo.name}}<span data-modified="modifiedName" @click="changeFrame">修改</span>
					</div>
					<div class="modifiedDataItem">
						角色：{{modifiedRole}}<span data-modified="modifiedRoleShow" @click="changeFrame">修改</span>
					</div>
					<div class="modifiedDataItem">
						地址：{{userInfo.address==""?'未设置':userInfo.address}}
						<span v-if="userInfo.address" data-modified="modifiedAddress" @click="changeFrame">修改</span>
						<span v-if="!userInfo.address" data-modified="modifiedAddress" @click="changeFrame">设置</span>
					</div>
					<div class="modifiedDataItem">
						说明：{{userInfo.guigui_remarks==null||userInfo.guigui_remarks==""?'未设置':userInfo.guigui_remarks}}
						<span v-if="userInfo.guigui_remarks" data-modified="modifiedGuiguiRemarks" @click="changeFrame">修改</span>
						<span v-if="!userInfo.guigui_remarks" data-modified="modifiedGuiguiRemarks" @click="changeFrame">设置</span>
					</div>
				</div>
			</div>
			<!--修改名字弹框-->
			<div class="modifiedDataframe" v-if="modified=='modifiedName'">
				<span class="modifiedDataframeTitle">修改昵称：<span @click="closeFrame" style="margin-left: 178px;cursor:pointer;">X</span></span>
				<input v-model="modifiedName" type="text" placeholder="请输入新昵称" />
				<span class="modifiedDataframeBtn" @click="modifiedBtn('modifiedName')">修改</span>
			</div>
			<!--修改地址弹框-->
			<div class="modifiedDataframe" v-if="modified=='modifiedAddress'">
				<span class="modifiedDataframeTitle">修改地址：<span @click="closeFrame" style="margin-left: 178px;cursor:pointer;">X</span></span>
				<input v-model="modifiedAddress" type="text" placeholder="请输入新地址" />
				<span class="modifiedDataframeBtn" @click="modifiedBtn('modifiedAddress')">修改</span>
			</div>
			<!--修改说明弹框-->
			<div class="modifiedDataframe" v-if="modified=='modifiedGuiguiRemarks'">
				<span class="modifiedDataframeTitle">修改说明：<span @click="closeFrame" style="margin-left: 178px;cursor:pointer;">X</span></span>
				<input v-model="modifiedGuiguiRemarks" type="text" placeholder="请输入说明" />
				<span class="modifiedDataframeBtn" @click="modifiedBtn('modifiedGuiguiRemarks')">修改</span>
			</div>
			<!--修改角色弹框-->
			<ul class="modifiedDataRole" v-if="modified=='modifiedRoleShow'">
				<li style="margin:0;">
					<span style="border:none;color:#ffffff;margin: 5px 0 0 160px;cursor:pointer;" @click="closeFrame">X</span>
				</li>
				<li>
					<span data-roleindex="role1" :class="roleindex=='role1'?'checked':''" @click="changeList"></span><span>木工</span>
				</li>
				<li>
					<span data-roleindex="role2" :class="roleindex=='role2'?'checked':''" @click="changeList"></span><span>门店</span>
				</li>
				<li>
					<span data-roleindex="role3" :class="roleindex=='role3'?'checked':''" @click="changeList"></span><span>柜柜工厂</span>
				</li>
				<li>
					<span data-roleindex="role4" :class="roleindex=='role4'?'checked':''" @click="changeList"></span><span>柜门厂</span>
				</li>
				<li>
					<span data-roleindex="role5" :class="roleindex=='role5'?'checked':''" @click="changeList"></span><span>设备商</span>
				</li>
				<li>
					<span data-roleindex="role6" :class="roleindex=='role6'?'checked':''" @click="changeList"></span><span>材料厂</span>
				</li>
				<li>
					<span data-roleindex="role7" :class="roleindex=='role7'?'checked':''" @click="changeList"></span><span>软件服务点</span>
				</li>
				<li>
					<span data-roleindex="role8" :class="roleindex=='role8'?'checked':''" @click="changeList"></span><span>其他</span>
				</li>
			</ul>
		</div>
	</div>
</template>

<script>
import { mapMutations } from 'vuex'
	export default {
		props:['userInfo'],
		data() {
			return {
				modified:"",	// 控制修改弹框是否出现
				modifiedName:"",// 要修改的名字
				modifiedAddress:"",//要修改的地址
				modifiedGuiguiRemarks:"",// 要修改的说明
				modifiedRole:"",//修改角色
				modifiedRoleShow:"", //控制角色弹框显示与隐藏
				roleindex:""// 控制修改角色
			}
		},
		mounted(){
			let that = this
			if(that.userInfo.identity == 0) {

        switch (that.userInfo.edition){
          case "木工版":
            that.modifiedRole = '木工'
            break
          case '设计版':case '设计版':
            that.modifiedRole = '门店'
            break
          case '工厂版':case '全能版':
            that.modifiedRole = '柜柜工厂'
            break
        }

				that.roleindex="no"
			} else {
				let identityNow = that.userInfo.identity
				if(identityNow == 1) {
					that.modifiedRole = "木工"
					that.roleindex="role1"
				} else if(identityNow ==2 ) {
					that.modifiedRole = "门店"
					that.roleindex="role2"
				} else if(identityNow ==3 ) {
					that.modifiedRole = "柜柜工厂"
					that.roleindex="role3"
				} else if(identityNow ==4 ) {
					that.modifiedRole = "柜门厂"
					that.roleindex="role4"
				} else if(identityNow ==5 ) {
					that.modifiedRole = "设备商"
					that.roleindex="role5"
				} else if(identityNow ==6 ) {
					that.modifiedRole = "材料厂"
					that.roleindex="role6"
				} else if(identityNow ==7 ) {
					that.modifiedRole = "软件服务点"
					that.roleindex="role7"
				} else if(identityNow ==8 ) {
					that.modifiedRole = "其他"
					that.roleindex="role8"
				}
			}
		},
		methods:{
			...mapMutations([
				'setUserInfo'
			]),
			changeInfo(){
				this.$emit('changeNavInfo',"guiguiFactory")
			},
			changeList(e){
				let that = this
				let roleindex = e.currentTarget.dataset.roleindex
			    if (roleindex != that.roleindex) {
					that.roleindex = roleindex
				}
			    // console.log(roleindex)
			    let roleIndexNum = -1
			    if(roleindex=="role1") {
					roleIndexNum = 1
					that.modifiedRole = "木工"
				} else if(roleindex=="role2" ) {
					roleIndexNum = 2
					that.modifiedRole = "门店"
				} else if(roleindex=="role3" ) {
					roleIndexNum = 3
					that.modifiedRole = "柜柜工厂"
				} else if(roleindex=="role4" ) {
					roleIndexNum = 4
					that.modifiedRole = "柜门厂"
				} else if(roleindex=="role5") {
					roleIndexNum = 5
					that.modifiedRole = "设备商"
				} else if(roleindex=="role6" ) {
					roleIndexNum = 6
					that.modifiedRole = "材料厂"
				} else if(roleindex=="role7" ) {
					roleIndexNum = 7
					that.modifiedRole = "软件服务点"
				} else if(roleindex=="role8") {
					roleIndexNum = 8
					that.modifiedRole = "其他"
				}
			    let modifiedNow = {
			    	uid:that.userInfo.id,
			    	identity:roleIndexNum
			    }
			    // that.axios({
			    // 	url:"https://guigui.thinkerx.com/user/editUserOther",
			    // 	method:"POST",
			    // 	data:{
			    // 		data:JSON.stringify(modifiedNow)
			    // 	}
			    // }).then(res => {
				// 		if (res.data.status == 1) {
				// 			this.$message('成功');
				// 			that.modified = "";
				// 		} else {
				// 			this.$message('修改失败');
				// 		}
			    // 	this.axios.get(`https://guigui.admin.thinkerx.com/wechat_app/user_info?phone=${this.userInfo.phone}`).then((res) => {
				// 			if (res.data.data) {
				// 				this.setUserInfo(res.data.data);
				// 			}
				// 		})
				// })
				that.$post("/guigui/user/editUserOther",{
					data:JSON.stringify(modifiedNow)
				},res => {
					if (res.status == 1) {
							this.$message('成功');
							that.modified = "";
						} else {
							this.$message('修改失败');
						}
						this.$get("/system/wechat_app/user_info",{
							phone: this.userInfo.phone
						},res => {  
							if (res.data) {
								this.setUserInfo(res.data);
							}
						})
				})
			},
			changeFrame(e){
				let that = this
				let modified = e.currentTarget.dataset.modified
			    if (modified != that.modified) {
					that.modified = modified
				}
			},
			closeFrame(){
				let that = this
				that.modified = ""
			},
			modifiedBtn(type){
				let that = this
				if(type == "modifiedName"){
					// 修改昵称

					let modifiedNow = {
						uid: that.userInfo.id,
						name: that.modifiedName,
					}

					// that.axios({
					// 	url:"https://guigui.thinkerx.com/user/edit_data",
					// 	method:"POST",
					// 	data:{
					// 		data:JSON.stringify(modifiedNow)
					// 	}
					// }).then(res => {
					// 	if (res.data.status == 1) {
					// 		this.$message('成功')
					// 		that.modified = ""
					// 	} else {
					// 		this.$message('修改失败');
					// 	}
					// 	this.axios.get(`https://guigui.admin.thinkerx.com/wechat_app/user_info?phone=${this.userInfo.phone}`).then((res) => {
					// 		if (res.data.data) {
					// 			this.setUserInfo(res.data.data);
					// 		}
					// 	})
					// })
					that.$post("/guigui/user/edit_data",{
						data:JSON.stringify(modifiedNow)
					},res => {
						if (res.status == 1) {
							this.$message('成功')
							that.modified = ""
						} else {
							this.$message('修改失败');
						}
						this.$get("/system/wechat_app/user_info",{
							phone:this.userInfo.phone
						},res => {  
							if (res.data) {
								this.setUserInfo(res.data);
							}
						})
					})
				} else if(type == "modifiedAddress") {
					// 修改地址
					let modifiedNow = {
						uid: that.userInfo.id,
						address: that.modifiedAddress
					}
					// that.axios({
					// 	url:"https://guigui.thinkerx.com/user/edit_data",
					// 	method:"POST",
					// 	data:{
					// 		data:JSON.stringify(modifiedNow)
					// 	}
					// }).then(res => {
					// 	if (res.data.status == 1) {
					// 		this.$message('成功')
					// 		that.modified = ""
					// 	} else {
					// 		this.$message('修改失败');
					// 	}
					// 	this.axios.get(`https://guigui.admin.thinkerx.com/wechat_app/user_info?phone=${this.userInfo.phone}`).then((res) => {
					// 		if (res.data.data) {
					// 			this.setUserInfo(res.data.data);
					// 		}
					// 	})
					// })
					that.$post("/guigui/user/edit_data",{
						data:JSON.stringify(modifiedNow)
					},res => {
						if (res.status == 1) {
							this.$message('成功')
							that.modified = ""
						} else {
							this.$message('修改失败');
						}
						this.$get("/system/wechat_app/user_info",{
							phone:this.userInfo.phone
						},res => {  
							if (res.data) {
								this.setUserInfo(res.data);
							}
						})
					})
				} else if(type == "modifiedGuiguiRemarks") {
					// 修改说明
					let modifiedNow = {
						uid: that.userInfo.id,
						guigui_remarks: that.modifiedGuiguiRemarks
					}
					// that.axios({
					// 	url:"https://guigui.thinkerx.com/user/editUserOther",
					// 	method:"POST",
					// 	data:{
					// 		data:JSON.stringify(modifiedNow)
					// 	}
					// }).then(res => {
					// 	if (res.data.status == 1) {
					// 		this.$message('成功')
					// 		that.modified = ""
					// 	} else {
					// 		this.$message('修改失败');
					// 	}
					// 	this.axios.get(`https://guigui.admin.thinkerx.com/wechat_app/user_info?phone=${this.userInfo.phone}`).then((res) => {
					// 		if (res.data.data) {
					// 			this.setUserInfo(res.data.data);
					// 		}
					// 	})
					// })
					that.$post("/guigui/user/editUserOther",{
						data:JSON.stringify(modifiedNow)
					},res => {
						if (res.status == 1) {
							this.$message('成功')
							that.modified = ""
						} else {
							this.$message('修改失败');
						}
						this.$get("/system/wechat_app/user_info",{
							phone:this.userInfo.phone
						},res => {  
							if (res.data) {
								this.setUserInfo(res.data);
							}
						})
					})
				}
			}
		}
	}
</script>

<style>
/*个人资料修改样式*/

.modifiedData {
	width:1050px;
    height:1110px;
    position: relative;
    float:left;
    margin-left:90px;
    background-color: #ffffff;
}
.modifiedData  ul {
	list-style-type: none;
}

.modifiedData .modifiedDataContainer {
	position: relative;
	width: 94%;
	height: 500px;
	margin: 41px 0 0 3%;
}

.modifiedData .modifiedDataTitle {
	margin-bottom: 20px;
	text-align: left;

}

.modifiedData .modifiedDataTitle span:nth-child(1) {
	font-size: 14px;
	color: #4D4D4D;
  	cursor: pointer;
}

.modifiedData .modifiedDataTitle span:nth-child(2) {
	font-size: 14px;
	color: #5147E7;
}

.modifiedData .modifiedDataBody {
	overflow: hidden;
}

.modifiedData .modifiedDataBody .modifiedDataImg {
	width: 50px;
	height: 50px;
	float: left;
}

.modifiedData .modifiedDataBody .modifiedDataImg img {
	width: 50px;
	height: 50px;
}

.modifiedData .modifiedDataBody .modifiedDatafix {
	width: 800px;
	height: 500px;
	margin-left: 20px;
	float: left;
}

.modifiedData .modifiedDataItem {
	height: 30px;
	margin-bottom: 14px;
	color: #4D4D4D;
	font-size: 16px;
	text-align: left;
}

.modifiedData .modifiedDataItem span {
	color: #5147E7;
	font-size: 13px;
	margin-left: 10px;
	cursor: pointer;
}

.modifiedData .modifiedDataframe {
	position: absolute;
	left: 50%;
	margin-left: -150px;
	top: 50%;
	margin-top: -100px;
	height: 160px;
	width: 300px;
	border-radius: 10px;
	background: rgba(52, 51, 52, 1);
	box-shadow: 0px 3px 6px rgba(0, 0, 0, 0.16);
	text-align: left;
}

.modifiedData .modifiedDataframe input {
	width: 90%;
	margin-left: 5%;
	height: 30px;
	font-size: 16px;
}

.modifiedData .modifiedDataframe .modifiedDataframeTitle {
	display: inline-block;
	height: 40px;
	font-size: 16px;
	margin: 10px 0 0 5%;
	color: #FFFFFF;
}

.modifiedData .modifiedDataframe .modifiedDataframeBtn {
	display: inline-block;
	position: absolute;
	width: 100px;
	height: 35px;
	font-size: 16px;
	left: 50%;
	margin-left: -50px;
	bottom: 20px;
	color: #FFFFFF;
	background-color: #5147E7;
	border-radius: 6px;
	line-height: 35px;
	text-align: center;
	cursor: pointer;
}

.modifiedData .modifiedDataRole {
	width: 180px;
	height: 286px;
	position: absolute;
	left: 50%;
	margin-left: -90px;
	top: 50%;
	margin-top: -143px;
	border-radius: 10px;
	background: rgba(52, 51, 52, 1);
	box-shadow: 0px 3px 6px rgba(0, 0, 0, 0.16);
	overflow: hidden;
}

.modifiedData .modifiedDataRole li {
	width: 100%;
	margin-left: 20px;
	margin-bottom: 12px;
	text-align: left;
}

.modifiedData .modifiedDataRole span:nth-child(1) {
	display: inline-block;
	width: 11px;
	height: 11px;
	border-radius: 50%;
	border: 1px solid rgba(224, 224, 224, 1);
}

.modifiedData .modifiedDataRole li span:nth-last-child(1) {
	margin-left: 6px;
	color: #FFFFFF;
}

.modifiedData .checked {
	background-color: #F27561;
}
</style>
